import { createContext } from 'react';

export interface BackofficeContextType {
  isVerified: boolean;
  isLoading: boolean;
  error: string | null;
  verify: (password: string) => Promise<boolean>;
  logout: () => void;
}

const BackofficeContext = createContext<BackofficeContextType | undefined>(undefined);

export default BackofficeContext;
